import { Component, OnInit } from "@angular/core";
import { SupportService } from "src/app/services/support.service";

@Component(
  {
    selector: 'app-opening-hours',
    templateUrl: 'opening-hours.component.html',
    styleUrls: ['opening-hours.component.scss']
  })
export class OpeningHoursComponent implements OnInit {
  public openingHours: string;

  public constructor(private supportService: SupportService) {
  }

  public ngOnInit() {
    this.supportService.getOpeningHours().subscribe(openingHours => {
      const monday = openingHours.Monday;
      this.openingHours = `${monday.Opens} - ${monday.Closes}`;
    });
  }

}

